export default {
  langEnglish: 'Английский',
  langRussian: 'Русский',
  langGerman: 'Немецкий',
  langChinese: 'Китайский',
  langUkraine: 'Украинский',
  changeLanguage: 'Сменить язык',
}


// WEBPACK FOOTER //
// ./src/locale/ru-RU/account.js